import config from 'company-management/config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    accounts: {
        url: `${authApi}/admin/users`,
        type: 'GET',
    },
    create: {
        url: `${authApi}/admin/users`,
        type: 'POST',
    },
    update: {
        url: `${authApi}/admin/users/{id}`,
        type: 'PUT',
    },
}
